import { useState } from 'react';

interface TypedConfirmDialogProps {
  title: string;
  message: string;
  confirmPhrase: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function TypedConfirmDialog({
  title,
  message,
  confirmPhrase,
  confirmLabel = 'Confirm',
  danger = false,
  onConfirm,
  onCancel,
}: TypedConfirmDialogProps) {
  const [typed, setTyped] = useState('');
  const matches = typed === confirmPhrase;

  return (
    <div className="admin-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="typed-confirm-title">
      <div className="admin-modal admin-modal-sm">
        <div className="admin-modal-header">
          <h3 id="typed-confirm-title">{title}</h3>
        </div>
        <div className="admin-modal-body">
          <p>{message}</p>
          <p>
            To continue, type <code className="admin-typed-confirm-phrase">{confirmPhrase}</code> below:
          </p>
          <input
            autoFocus
            className="admin-typed-confirm-input"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            aria-label={`Type ${confirmPhrase} to confirm`}
          />
        </div>
        <div className="admin-modal-footer">
          <button type="button" className="admin-btn" onClick={onCancel}>Cancel</button>
          <button
            type="button"
            className={`admin-btn ${danger ? 'admin-btn-danger' : 'admin-btn-primary'}`}
            disabled={!matches}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
